import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import BuildIcon from "@mui/icons-material/Build";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import ThumbUpIcon from "@mui/icons-material/ThumbUp"; 
import { formatNumber } from "../../utility/formatNumber";

const TicketSummary = ({ handleNavigate, status }) => {
  const cards = [
    {
      label: "Total Tickets",
      value: status.totalCount,
      icon: <ConfirmationNumberIcon sx={{ fontSize: 40, color: "#00BFFF" }} />,
    },
    {
      label: "Open Tickets",
      value: status.openCount,
      icon: <HourglassEmptyIcon sx={{ fontSize: 40, color: "#FFA500" }} />,
    },
    {
      label: "In Progress",
      value: status.inProgressCount,
      icon: <BuildIcon sx={{ fontSize: 40, color: "#FFD700" }} />,
    },
    {
      label: "Closed Tickets",
      value: status.closedCount,
      icon: <CheckCircleIcon sx={{ fontSize: 40, color: "#32CD32" }} />,
    },
    {
      label: "Escalated",
      value: status.escalatedCount,
      icon: <PriorityHighIcon sx={{ fontSize: 40, color: "#FF4500" }} />,
    },
    {
      label: "Resolved",
      value: status.resolvedCount,
      icon: <ThumbUpIcon sx={{ fontSize: 40, color: "#FC6A03" }} />,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 2,
        mb: 4,
        justifyContent:"center"
      }}
    >
      {cards.map(({ label, value, icon }, idx) => (
        <Box
          onClick={() => {
            handleNavigate();
          }}
          key={idx}
          sx={{
            flex: "0 0 calc(33.333% - 16px)", 
            minWidth: "250px", 
            maxWidth: "calc(33.333% - 16px)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          <Paper
            elevation={3}
            sx={{
              height: "100%",
              p: 3,
              textAlign: "center",
              backdropFilter: "blur(10px)",
              background: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: 3,
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            <Box sx={{ mb: 1 }}>{icon}</Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, whiteSpace: "nowrap" }}
              >
                {label}:
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                {formatNumber(value)}
              </Typography>
            </Box>
          </Paper>
        </Box>
      ))}
    </Box>
  );
};

export default TicketSummary;
